import { render, staticRenderFns } from "./StaffAreaSelect.vue?vue&type=template&id=91bfdd3a&"
import script from "./StaffAreaSelect.vue?vue&type=script&lang=js&"
export * from "./StaffAreaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports